import * as React from "react";
import { useState } from "react";
import { Button, Icon, Label, LabelDetail } from "semantic-ui-react";
import "./filter-configuration.css";
import { Filter } from "../../globals/types";

type FilterOption = {
    attribute: string;
    attributeDisplayText: string;
    values: string[]
}

export default function FilterConfiguration({
                                                filterOptions,
                                                initialFilters,
                                                onFilterAdded,
                                                onFilterRemoved
                                            }:
                                                {
                                                    filterOptions: FilterOption[];
                                                    initialFilters: Filter[];
                                                    onFilterAdded: (filter: Filter) => void;
                                                    onFilterRemoved: (filter: Filter) => void
                                                }): JSX.Element {
    const [nextFilterId, setNextFilterId] = useState<number>(0);
    const [selectedFilterOption, setSelectedFilterOption] = useState<FilterOption>();
    const [selectedFilterValue, setSelectedFilterValue] = useState<string>("select-value");
    const [filters, setFilters] = useState<Filter[]>(initialFilters);

    return (
        <div className="filterConfiguration">
            <div className="newFilter">
                <select className="ui selection dropdown"
                        value={selectedFilterOption === undefined ? "select-attribute" : selectedFilterOption.attribute}
                        onChange={e => setSelectedFilterOption(filterOptions.find(o => o.attribute === e.target.value)!)}>
                    <option value="select-attribute" disabled={true}>-- Filter-Attribut wählen --</option>
                    {filterOptions.map(o =>
                        <option key={o.attribute} value={o.attribute}>{o.attributeDisplayText}</option>
                    )}
                </select>
                <select className="ui selection dropdown" value={selectedFilterValue}
                        onChange={e => setSelectedFilterValue(e.target.value)}>
                    <option value="select-value" disabled={true}>-- Filter-Wert wählen --</option>
                    {selectedFilterOption !== undefined &&
                        selectedFilterOption.values.map(v =>
                            <option key={v} value={v}>{v}</option>
                        )}
                </select>
                <Button type="button"
                        title="Filter hinzufügen"
                        disabled={selectedFilterValue === "select-value"}
                        onClick={() => {
                            const newFilter = {
                                id: nextFilterId,
                                attribute: selectedFilterOption!.attribute,
                                attributeDisplayText: selectedFilterOption!.attributeDisplayText,
                                value: selectedFilterValue
                            };
                            setFilters(filters.concat([newFilter]));
                            setNextFilterId((oldId) => ++oldId);
                            setSelectedFilterOption(undefined);
                            setSelectedFilterValue("select-value");
                            onFilterAdded(newFilter);
                        }}>
                    +
                </Button>
            </div>
            <div className="filters">
                {filters.map(f =>
                    <Label key={f.id} size="large" basic={true}>
                        {f.attributeDisplayText}
                        <LabelDetail>{f.value}</LabelDetail>
                        <Icon name="delete"
                              onClick={() => {
                                  const newFilters = filters.filter(fi => fi.id !== f.id);
                                  setFilters(newFilters);
                                  onFilterRemoved(f);
                              }}/>
                    </Label>)}
            </div>
        </div>
    );
}
